import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestDataSystem_String,
  ResponseModels_InvoicesBackoffice_OutstandingInvoicesModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetOutstandingInvoicesForAdministrator = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody?: RequestDataSystem_String;
};
/**
 * Gets overview of all the outstanding invoices of the customers that belong to an administrator.
 *
 * @returns ResponseModels_InvoicesBackoffice_OutstandingInvoicesModel Success
 */
export function getOutstandingInvoicesForAdministrator(
  { businessUnit, label, requestBody }: GetOutstandingInvoicesForAdministrator,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_InvoicesBackoffice_OutstandingInvoicesModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/customers/invoices/outstanding`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
